import {action} from "mobx";
import subCompanyService from "../services/subCompanyService";

class subCompanyStore {
    @action searchCustomers = async (searchText, selectedSubCompanyId) => {
        try {
            const response = await subCompanyService.searchCustomers(
                searchText,
                selectedSubCompanyId
            );
            return response.data;
        } catch (error) {
            return [];
        }
    };
    @action calculatePrice = async params => {
        try {
            const response = await subCompanyService.calculatePrice(params);
            return response;
        } catch (error) {
            return error;
        }
    };
    @action getCredit = async params => {
        try {
            const response = await subCompanyService.getCredit(params);
            return response.data;
        } catch (error) {
            return [];
        }
    };
    @action listWithCredit = async params => {
        try {
            const response = await subCompanyService.listWithCredit(params);
            return response.data;
        } catch (error) {
            return [];
        }
    };
}

export default new subCompanyStore();
